import styled from "styled-components"
import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import LivingImage from "./living_room.jpg"
import ExteriorImage from "./exterior_entrance.jpg"
import QuoteIcon from "./quote.svg"
import { device } from "../../../theme/device"
import { IconButton } from "@material-ui/core"

export const Text1 = styled.p`
  font-family: OuterSans-Regular;
  font-style: normal;
  font-weight: 600;
  font-size: 1vw;
  color: #75938f;
  margin: 0;
  padding: 0;
  line-height: 350%;
`

export const Text2 = styled.p`
  font-family: AzoSans-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 0.75vw;
  color: #000000;
  margin: 0;
  padding: 0;
  line-height: 150%;
  margin-bottom: 1em;
  @media ${device.padPro} {
    font-size: 0.87vw;
  }
`

export const Text3 = styled.p`
  font-family: AzoSans-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 0.7vw;
  color: #3a4653;
  margin: 0;
  padding: 0;
  line-height: 150%;
  margin-bottom: 0em;
  @media ${device.padPro} {
    font-size: 1vw;
  }
`

export const Text4 = styled.p`
  font-family: AzoSans-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 0.9vw;
  color: #75938f;
  margin: 0;
  padding: 0;
  line-height: 150%;
  margin-bottom: 0em;
  @media ${device.padPro} {
    font-size: 1.2vw;
  }
`

export const Holder = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
`

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`

export const LeftHolder = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 30%;
  height: 100%;
`

export const MiddleHolder = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 30%;
  height: 100%;
`

export const RightHolder = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 40%;
`
export const RightTitle = styled.img`
  margin: 2em;
`
export const RightImage = styled.div`
  width: 100%;
  height: 100%;
  background: url(${ExteriorImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`

export const LeftPic = styled.div`
  width: 100%;
  height: 33%;
  background: url(${LivingImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`
export const LeftBottomHolder = styled.div`
  height: 67%;
  padding: 0.8vw 2vw 3.5rem 2vw;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 1vw;
`
export const TaylorPic = styled.img`
  width: 95%;
  margin-bottom: 1vw;
  pointer-events: none;
  user-select: none;
`
export const Divider = styled.div`
  width: 100%;
  height: 2px;
  margin: 0.1vw 0 1vw 0;
  background-color: #5f7774;
`

export const MiddleTopHolder = styled.div`
  height: 45%;
  padding: 3vw;
  display: flex;
  flex-direction: column;
`
export const MiddleBottomHolder = styled.div`
  position: relative;
  padding: 3vw;
  display: flex;
  flex-direction: column;
  background-color: #dae2e2;
`
export const CaptionHolder = styled.q`
  position: relative;
  padding: 0 2vw;
  font-style: normal;
  font-weight: 600;
  font-size: 1.2vw;
  color: #93a6b3;
  text-align: center;
  line-height: 150%;
  @media ${device.padPro} {
    font-size: 1.6vw;
    padding: 0 1vw;
  }
  &:after {
    content: "";
    background-image: url(${QuoteIcon});
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    width: 2vw;
    height: 2.1vw;
    position: absolute;
    top: -1.5rem;
    left: 0;
  }

  &:before {
    content: "";
    background-image: url(${QuoteIcon});
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    width: 2vw;
    height: 2.1vw;
    position: absolute;
    bottom: -1.5rem;
    right: 0;
    transform: rotateZ(180deg);
  }
`
export const AboutLink = styled(Link)`
  position: absolute;
  left: 1rem;
  bottom: 1rem;
`
export const BackButton = styled(IconButton)`
  width: 3em;
  height: 3em;
`
export const BackIcon = styled.img`
  width: 100%;
`
